import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Component({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-kit-tabs-header-item',
  templateUrl: 'tabs-header-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsHeaderItemComponent {
  // @ts-expect-error
  @Input() active: boolean;
  // @ts-expect-error
  @Input() label: string;
  @Output()
  nativeElData: EventEmitter<{
    width: number;
    offset: number;
  }> = new EventEmitter();

  @HostBinding('class')
  get classes() {
    return this.active ? 'tabs__item active' : 'tabs__item';
  }

  @HostListener('mouseenter', ['$event.target'])
  onResize() {
    this.nativeElData.emit({
      width: this.el.nativeElement.offsetWidth,
      offset: this.el.nativeElement.offsetLeft,
    });
  }
  constructor(private el: ElementRef) {}
}
